import { STANDARD, INSTANT, VENDOR } from './constants';

export default {
  [STANDARD]: {
    TABLE_COLUMNS: [
      {
        key: 'settlementTypeCTA',
        displayName: '',
        width: 0.04,
      },
      {
        key: 'addedOn',
        displayName: 'Initiated At',
        tooltip: 'Initiated At',
        width: 0.1,
      },
      {
        key: 'period',
        displayName: 'Transaction Period',
        width: 0.14,
      },
      {
        key: 'utr',
        displayName: 'UTR',
        width: 0.8,
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 0.8,
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 2,
      },
      // [1.5, 1.5, 1.2, 1.4, 1.5, 1, 1.5, 1.2, 0.6],
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [
      {
        key: 'utrNo',
        text: 'UTR No.',
        value: 'utr',
        placeholder: 'Enter UTR No.',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
    ],
  },
  [INSTANT]: {
    TABLE_COLUMNS: [
      {
        key: 'addedOn',
        displayName: 'Date & Time',
        width: 0.15,
      },
      {
        key: 'settlementId',
        displayName: 'Settlement ID',
        width: 0.15,
      },
      {
        key: 'transactionAmount',
        displayName: 'Txn. Amt.',
        width: 0.15,
        align: 'right',
      },
      {
        key: 'adjustment',
        displayName: 'Adjustment Amt.',
        width: 0.15,
        align: 'right',
      },
      {
        key: 'charges',
        displayName: 'Charges',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 0.1,
      },
      {
        key: 'settlementLinkCTA',
        displayName: '',
        width: 0.05,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [VENDOR]: {
    TABLE_COLUMNS: [
      {
        key: 'addedOn',
        displayName: 'Date & Time',
        width: 0.15,
      },
      {
        key: 'period',
        displayName: 'Period',
        width: 0.11,
      },
      {
        key: 'settlementType',
        displayName: 'Type',
        width: 0.08,
      },
      {
        key: 'merchantVendorId',
        displayName: 'Vendor ID',
        width: 0.12,
      },
      {
        key: 'payoutId',
        displayName: 'Settlement ID',
        width: 0.12,
      },
      {
        key: 'utr',
        displayName: 'UTR No.',
        width: 0.12,
      },
      {
        key: 'adjustmentAmount',
        displayName: 'Adjustment Amt.',
        width: 0.14,
        align: 'right',
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 0.12,
        align: 'right',
      },
      {
        key: 'status',
        displayName: 'Status',
        width: 0.12,
      },
      {
        key: 'failureReason',
        displayName: 'Failure Reason',
        width: 0.13,
      },
      {
        key: 'settlementLinkCTA',
        displayName: '',
        width: 0.06,
      },
    ],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  VENDOR_FOR_SETTLEMENT_V2_UI: {
    TABLE_COLUMNS: [
      {
        key: 'settlementTypeCTA',
        displayName: '',
        width: 0.04,
      },
      {
        key: 'addedOn',
        displayName: 'Initiated At',
        tooltip: 'Initiated At',
        width: 0.14,
      },
      {
        key: 'payoutId',
        displayName: 'Vendor ID',
        tooltip: 'Vendor ID',
        width: 0.1,
      },
      {
        key: 'period',
        displayName: 'Payment Range',
        width: 0.18,
      },
      {
        key: 'utr',
        displayName: 'UTR',
        width: 0.14,
      },
      {
        key: 'settledAmount',
        displayName: 'Settled Amt.',
        width: 0.1,
      },
      {
        key: 'settlementStatus',
        displayName: 'Status',
        width: 0.3,
      },
    ],
  },
};
